import React, { useEffect, useState } from 'react';

export type WindowDimension = {
  width: number;
  height: number;
};

// Help function to parse window size from the window object
const getWindowDimensions = (): WindowDimension => {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
};

/**
 * Get window size in pixels - Width and Height
 *
 * This can be used to get actual screen size but also to get screen size after resize.
 *
 * @return the {@link WindowDimension} object containing height and width of the screen
 *
 */
export const useWindowResize = (): WindowDimension => {
  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    ...windowDimensions
  };
};
